export default {
  issues: '/issues',
  login: '/login',
  signup: '/signup',
  pagenotfound: '/404',
  resetpassword: '/reset-password',
  forgotpassword: '/forgot-password',
  issuedetails: '/issue-details/:id',
  technologies: '/technologies',
  profile: '/user/profile',
  user_collections: '/user/collections',
  user_teams: '/user/teams',
  search: '/search',
  integrations: '/integrations',
  dashboard: '/dashboard',
  resources: '/resources',
  collections: '/collections',
  collection_settings: '/collection/settings/:id',
  collection_schedule: '/collection/schedule/:id',
  collection_exports: '/collection/exports/:id',
  entity_details: '/search/entity/:entityId',
};
